import connect from './connect';

export { PlatformUsersList } from './PlatformUsersList';

export default connect;
